import { Truck } from "../../types/truck";
import Api from "../api";

export default async function apiGetTruck(id: string) {
  return await Api.get<Truck>({
    input: `/api/v1/truck/${id}`,
  });
}
